export enum ComponentsEnum {
  SLIDER,
  CAROUSEL,
  DIGITALIZE,
  METRICS,
  DEMO,
  FAQS,
  RECORD
}
